var lists_default = {
  "fontElementMap": "mPO32",
  "orderedlist": "QXanO",
  "bulletedlist": "_8kUFx",
  "listItem": "M1zbw"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
